module.exports = __webpack_public_path__ + "static/media/bm.983adcb8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bm.svg
// module id = 2050
// module chunks = 0